








import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
    name: 'AppLink',
})
export default class AppLink extends Vue {
    @Prop({required: true}) public content!: string;
    @Prop({default: ''}) public href!: string;
    @Prop({default: '_blank'}) public target!: string;
    @Prop({default: 'primary'}) public mode!: string;
}
